import main from "./main";
import auth from "./auth";
import valutes from "./valutes";
import crossRate from "./crossRate";
import wallets from "./wallets";
import transactions from "./transactions";
import transactionsNew from "./transactionsNew";
import users from "./users";
import outputs from "./outputs";
import balanceAccounts from "./balanceAccounts";
import ledgerExchanges from "./ledgerExchanges";
import depositAccounts from "./depositAccounts";
import ledgerValutes from "./ledgerValutes";
import ledgerCredentials from "./ledgerCredentials";
import ledgerDashboards from "./ledgerDashboards";
import ledgerExchange from "./ledgerExchange";
import ledgerBi from "./ledgerBi";
//
export default {
  main,
  auth,
  valutes,
  crossRate,
  wallets,
  transactions,
  transactionsNew,
  users,
  outputs,
  balanceAccounts,
  ledgerExchanges,
  depositAccounts,
  ledgerValutes,
  ledgerCredentials,
  ledgerDashboards,
  ledgerExchange,
  ledgerBi
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js